import Dom from './Dom';

/**
 * @returns Dom
 */
export const createInstance = () => new Dom();

const instance = new Dom();

export default instance;



// WEBPACK FOOTER //
// ./src/Dom/index.js